<template>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <div aria-live="assertive" :class="['fixed inset-0 flex px-4 py-6 pointer-events-none sm:p-6', boxVerticalPosition]" style="z-index: 100">
        <div :class="['w-full flex flex-col space-y-4', boxHorizontalPosition]">
            <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
            <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <div v-if="visible" class="max-w-sm w-full bg-green-50 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden border border-green-200">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <i :class="['text-green-400 text-xl', icon]" />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-green-900">Successful!</p>
                                <p class="mt-1 text-sm text-green-700">{{text}}</p>
                            </div>
                            <i :class="['text-lg text-gray-400 hover:text-gray-500 cursor-pointer', closeIcon]" @click="visible = false"/>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

import {INFO_BOX_TIMEOUT} from "../master/constants";

export default {
    name: "success-box",
    data(){
        return {
            visible: this.$props.show
        }
    },
    props: {
        show: { type: Boolean, default: false},
        text: { type: String, default: "The changes made successfully."},
        icon: { type: String, default: 'fal fa-check-circle'},
        closeIcon: { type: String, default: 'fal fa-times'},
        horizontalPosition: { type: String, default: 'right'},
        verticalPosition: { type: String, default: 'top'},
    },

    watch: {
        show: function(newVal) { // watch it
            this.visible = newVal
            if(newVal){
                setTimeout(() => this.visible = false, INFO_BOX_TIMEOUT)
            }
        }
    },

    computed: {
        boxHorizontalPosition() {
            return this.$props.horizontalPosition.toLowerCase() === 'left' ? 'items-start' : 'items-end'
        },
        boxVerticalPosition() {
            return this.$props.verticalPosition.toLowerCase() === 'bottom' ? 'items-end' : 'items-start';
        }
    }
}
</script>